import { render, staticRenderFns } from "./rateTableItem.vue?vue&type=template&id=7df80550&scoped=true"
import script from "./rateTableItem.vue?vue&type=script&lang=js"
export * from "./rateTableItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df80550",
  null
  
)

export default component.exports